<template>
  <div>
    <button
      type="button"
      class="report-item"
      :disabled="processingFile"
      @click="requestReport"
    >
      <BaseMiniSpinner v-if="processingFile" class="report-spinner" />
      <i v-else class="mdi mdi-file-chart-outline"></i>
      Request report from order
    </button>
    <a
      target="_blank"
      class="report-item"
      :href="`${url}/orders/print_purchase_order/${orderNumber}`"
    >
      <i class="mdi mdi-file-pdf-box"></i>
      View report with images (PDF)
      <i class="mdi mdi-open-in-new external"></i>
    </a>
    <a
      target="_blank"
      class="report-item"
      :href="`${url}/orders/print_order_alt/${orderNumber}`"
    >
      <i class="mdi mdi-file-pdf-box"></i>
      View Order-Quote (PDF) with Alt description
      <i class="mdi mdi-open-in-new external"></i>
    </a>
    <a
      target="_blank"
      class="report-item"
      :href="`${url}/orders/print_purchase_order2/${orderNumber}`"
    >
      <i class="mdi mdi-image-multiple"></i>
      View report with images
      <i class="mdi mdi-open-in-new external"></i>
    </a>
    <BaseModal id="order-report-modal" v-model="showResponse">
      <div class="flex flex-col justify-center h-96" v-if="response">
        <p>Status: {{ response.reportStatus }}</p>
        <p>Details: {{ response.result.message }}</p>
        <a
          target="_blank"
          class="btn-dark-button mt-10 w-36 mx-auto"
          :href="response.s3Route"
        >
          Download File
        </a>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { getSavedState } from "@/helpers/LocalStorage.js";
import { requestReport as requestReportToStore } from "@/api/store/ReportGeneratorService.js";
export default {
  name: "OrderReport",
  props: {
    orderNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      processingFile: false,
      response: null,
      showResponse: false
    };
  },
  computed: {
    url() {
      return getSavedState("store.selectedStoreUrl") || null;
    }
  },
  methods: {
    requestReport() {
      if (this.processingFile) {
        return;
      }
      this.response = null;
      const formValues = {
        fileType: "order_report",
        otherOptions: {
          orderNumber: this.orderNumber
        }
      };
      this.processingFile = true;
      requestReportToStore(formValues)
        .then(res => {
          this.response = res;
          console.log(res);
          this.$toast.open({
            message: `Report generated`,
            type: "success",
            position: "top-right"
          });
          this.showResponse = true;
        })
        .catch(() => {
          this.$toast.open({
            message: `error generating report`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.processingFile = false;
          this.$emit("reportGenerationFinished");
        });
    }
  }
};
</script>
<style lang="postcss">
#order-report-modal .modal-content {
  max-width: 400px;
  max-height: 384px;
}
</style>
<style lang="scss" scoped>
/* Mismo aspecto que .menu-item del menu de opciones de la orden */
.report-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 36px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  text-align: left;
  cursor: pointer;

  i {
    flex-shrink: 0;
    font-size: 18px;
    color: #6b7280;
  }

  .external {
    margin-left: auto;
    font-size: 14px;
    color: #6b7280;
  }

  .report-spinner {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  &:hover:not(:disabled) {
    background: #f3f4f6;
    color: #111827;

    i {
      color: #126e6a;
    }
  }

  &:disabled {
    cursor: progress;
    opacity: 0.7;
  }

  @media (max-width: 767px) {
    min-height: 44px;
  }
}
</style>
